import type { QuizBuilderSectionSchema } from '@repo/schemas/quiz/quizBuilder';
import type { QuizSectionSchema } from '@repo/schemas/quiz/quizSection';

import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { quizSectionSchema } from '@repo/schemas/quiz/quizSection';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router';

import { useQuizBuilder } from '@/context/quiz-builder';

export function useQuizBuilderContentSection() {
  const navigate = useNavigate();
  const { sectionIndex } = useParams();
  const { sectionsForm, sectionsFieldArray, saveDraftData } = useQuizBuilder();

  const sectionIndexNumber: number | undefined = sectionIndex ? parseInt(sectionIndex, 10) : undefined;

  const defaultValues: QuizBuilderSectionSchema = sectionsForm.getValues(`content.${sectionIndexNumber ?? 0}`);

  const form = useForm<QuizSectionSchema>({
    defaultValues,
    mode: 'onChange',
    resolver: standardSchemaResolver(quizSectionSchema),
  });

  //trigger validation on component mount
  useEffect(() => {
    form.trigger();
  }, []);

  const onSubmit = (data: QuizSectionSchema) => {
    if (sectionIndexNumber === undefined) return;

    sectionsFieldArray.update(sectionIndexNumber, {
      ...data,
      questions: defaultValues.questions,
    });
    saveDraftData();
    navigate('../questions');
  };

  return { form, onSubmit, sectionIndexNumber };
}
